import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.bio.title',
        defaultMessage: 'Biometrics',
    },
    gotIt: {
        id: 'modal.3ds.bio.got_it',
        defaultMessage: 'Got it',
    },
    description: {
        id: 'modal.3ds.bio.description',
        defaultMessage:
            "When you have a transaction to confirm, you'll see it in the mobile app — approve with your fingerprint or face, just like unlocking your phone.",
    },
})
